"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../hooks");
var FilterWidget_1 = __importDefault(require("../FilterWidget"));
var FormatText_1 = __importDefault(require("../FormatText"));
var GridView_1 = __importDefault(require("../GridView"));
var Table_1 = __importDefault(require("../Table"));
var TableActionDelete_1 = __importDefault(require("../TableActionDelete"));
var TableActionEdit_1 = __importDefault(require("../TableActionEdit"));
var Widget_1 = __importDefault(require("../Widget"));
var CrudList = function (props) {
    var title = props.title, filter = props.filter, table = props.table, onFilter = props.onFilter, onDelete = props.onDelete, selectItem = props.selectItem, extractItemId = props.extractItemId, updatePermissions = props.updatePermissions, deletePermissions = props.deletePermissions;
    var url = hooks_1.useRouter().match.url;
    var _a = filter || {}, form = _a.form, actions = _a.actions, initialValues = _a.initialValues;
    var renderActions = react_1.useMemo(function () { return function (_, item) { return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TableActionEdit_1.default, { onClick: function () { return selectItem(item); }, linkTo: url + "/edit/" + (extractItemId ? extractItemId(item) : item.id), viewPermission: updatePermissions }),
        react_1.default.createElement(TableActionDelete_1.default, { onClick: function () { return onDelete(item.id); }, viewPermission: deletePermissions }))); }; }, [onDelete, extractItemId, selectItem, url, updatePermissions, deletePermissions]);
    return (react_1.default.createElement(GridView_1.default, { onSubmit: onFilter, initialValues: initialValues },
        form && react_1.default.createElement(FilterWidget_1.default, { actions: actions }, form),
        react_1.default.createElement(Widget_1.default, { title: react_1.default.createElement(FormatText_1.default, { id: "ui.commons.register.list", params: { entity: title } }) },
            react_1.default.createElement(Table_1.default, __assign({ renderActions: renderActions }, table)))));
};
exports.default = CrudList;
